import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n/config';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DataProvider } from './DataContext'; // Unified context

import Home from './pages/Home';
import Blogs from './pages/Blogs';
import BlogPage from './pages/BlogPage';
import MainLayout from './layout/MainLayout';
import OurStory from './pages/OurStory';
import AboutBYG from './pages/AboutBYG';
import Demo from './pages/Demo';
import Admin from './pages/Admin';


const router = (
	<DataProvider>
		<Router basename={process.env.PUBLIC_URL}>
			<Routes>
				<Route element={<MainLayout />}>
					<Route path="/" element={<Home />} />
					<Route path="/blogs" element={<Blogs />} />
					<Route path="/blogs/:id" element={<BlogPage />} />
					<Route path="/our-story" element={<OurStory />} />
					<Route path="/about-byg" element={<AboutBYG />} />
					<Route path="/demo" element={<Demo />} />
				</Route>
				<Route path="/admin" element={<Admin />} />
			</Routes>
		</Router>
	</DataProvider>
);

const root = createRoot(document.getElementById('root'));
root.render(router);
